import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/sharpe-ratio',
  component: () => import('../../routes/SharpeRatio.svelte'),
  card: {
    id: 'sharpe-ratio',
    title: 'Sharpe Ratio Calculator',
    description: 'Measure risk-adjusted returns by comparing portfolio performance against a risk-free benchmark. Enter periodic returns to evaluate investment quality.',
    icon: 'speed',
    iconBgClass: 'bg-purple-50',
    iconTextClass: 'text-purple-600',
    href: '/sharpe-ratio',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Sharpe Ratio Calculator – Risk-Adjusted Return Calculator',
    description: 'Free Sharpe Ratio calculator. Measure risk-adjusted investment returns by comparing portfolio performance against a risk-free benchmark. Enter periodic returns to calculate the Sharpe Ratio, annualized value, and key statistics.',
  },
};

export default meta;
